import { NgModule } from '@angular/core';
import { InitWorkflowService } from './init.workflow.service';
import { RouteActionsService, RouteAction } from './routeactions.service';
import { ExternalActionsService } from './external.actions.service';
import { ExternalAction, ExternalActionData } from './external.action.interface';
import { DeletePlantActions } from './external-actions/delete.plant.action';
import { DeleteUserActions } from './external-actions/delete.user.action';
import { WorkflowMessagesService } from './workflow.messages';

@NgModule({
    providers : [
        InitWorkflowService,
        RouteActionsService,
        ExternalActionsService,
        DeletePlantActions,
        DeleteUserActions,
        WorkflowMessagesService
    ]
})
export class WorkflowModule {}

export {
    InitWorkflowService,
    RouteActionsService,
    RouteAction,
    ExternalActionsService,
    ExternalActionData,
    ExternalAction,
    WorkflowMessagesService
}